import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Note} from '../types/note';
import {Stream} from '../types/stream';
import {environment} from '../../../environments/environment';

import { Location } from '@angular/common';

@Component({
    selector: 'social-sharing',
    templateUrl: './social-sharing.component.html',
    styleUrls: ['./social-sharing.component.scss']
})
export class SocialSharingComponent implements OnInit {
    @ViewChild('socialSharingModal', {static: false}) socialSharingModal: ElementRef;
    @Input() note: Note;
    @Input() stream: Stream;
    @Input() customClass: string;

    socialItems: string[] = ['facebook', 'twitter'/*, 'google-plus'*/, 'reddit'];
    link: string;
    embedText: string;
    linkCopied = false;
    embedTextCopied = false;

    constructor(
        private modalService: NgbModal,
        private location: Location) {
    }

    ngOnInit() {
      // Old.  NOTE NEVER user window object because it will fail on universal
      //this.link = this.stream && window.location.href.match(/user/gi) ?
      // `${window.location.origin}/streams/${this.stream.id}/${this.stream['name' || 'urlName']}` : window.location.href;

      this.link = environment.urlBasePrefix + this.location.path();
      // link is full URL
      // http://localhost:4200/notes/5718643555958784_1_1568887576006/incognito%20iphone2

      this.embedText = `<iframe style="width:640px;height:400px" src="${this.link}" frameborder="0" allowfullscreen> </iframe>`;
    }

    openModal() {
        this.modalService.open(this.socialSharingModal, { windowClass: 'social-modal' });
    }

    setSocialLink(social: string) {
      let url: string;

      const name = (this.note || this.stream).name;
      const id = (this.note || this.stream).id;
      const urlName = (this.note || this.stream)['name' || 'urlName'];
      const urlType = this.note ? 'notes' : 'streams';

      switch (social) {
        case 'twitter':
          const encodedTwitterUrl = encodeURIComponent(`${this.link}&hashtags=notd,${name}`);
          url = `https://twitter.com/intent/tweet?text=${name}&url=${encodedTwitterUrl}`;
          break;
        case 'facebook':
          console.log(`${this.link}/${urlType}/${id}/${urlName}`);
          const encodedFbUrl = encodeURIComponent(`${this.link}/${urlType}/${id}/${urlName}`);
          url = `https://www.facebook.com/sharer/sharer.php?u=${encodedFbUrl}`;
          break;
        // case 'google-plus':
        //     url = 'https://plus.google.com/share?url=https%3A%2F%2Fnotd.io%2F' + this.noteId;
        //     break;
        case 'reddit':
          url = `http://www.reddit.com/submit?url=${encodeURIComponent(this.link)}/${urlType}/${id}/${urlName}`;
          break;
      }

      return url;
    }

    urlifyName(name: string) {
      let str = name.replace(/^\s+|\s+$/g, '');
      str = str.toLowerCase();

      const from = 'àáäâèéëêìíïîòóöôùúüûñç·/_,:;';
      const to   = 'aaaaeeeeiiiioooouuuunc------';
      for (let i = 0, l = from.length ; i < l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
      }

      str = str.replace(/[^a-z0-9 -]/g, '')
        .replace(/\s+/g, '-')
        .replace(/-+/g, '-');

      return str;
    }

}
